import * as React from 'react';
import classnames from 'classnames';
import { RemoveVoucherCodeContainer } from '../../VoucherCodes/RemoveVoucherCode/RemoveVoucherCodeContainer.js';
import '@grandvisionhq/common';
import '@grandvisionhq/forms';
import '@grandvisionhq/graphql';
import '@grandvisionhq/state';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '../../../operations/fragments/cart-details.js';
import '../../../operations/fragments/cart-validation-errors.js';
import '../../../operations/fragments/recover-inactive-cart-failure.js';
import '../../../operations/fragments/recover-inactive-cart-result.js';
import '../../../operations/mutations/add-cart-line-items.js';
import '../../../operations/mutations/add-cart-voucher-codes.js';
import '../../../operations/mutations/create-cart.js';
import '../../../operations/mutations/remove-cart-voucher-codes.js';
import '../../../operations/mutations/remove-cart-line-items.js';
import '../../../operations/mutations/update-cart-line-items.js';
import '../../../operations/mutations/replace-line-item-contact-lenses-bundle-benelux.js';
import '../../../operations/mutations/recover-inactive-cart.js';
import '../../../operations/queries/get-cart.js';
import '../../../operations/queries/get-total-line-items.js';
import '../../../operations/queries/get-cart-estimated-delivery.js';
import { SubscriptionContainer } from '../containers/SubscriptionContainer.js';

const Subscription = ({ className , lineItems , hideSubscriptionExplainer , subscription , voucherCodes  })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames('cart-totals', className),
        "data-t": "cart-totals"
    }, voucherCodes && voucherCodes.map((code)=>/*#__PURE__*/ React.createElement(RemoveVoucherCodeContainer, {
            key: code,
            voucherCode: code
        })
    ), /*#__PURE__*/ React.createElement(SubscriptionContainer, {
        lineItems: lineItems,
        subscription: subscription,
        hideSubscriptionExplainer: hideSubscriptionExplainer
    }))
;

export { Subscription };
//# sourceMappingURL=Subscription.js.map
